// @ts-check
/**
 * Exportação para CSV.
 *
 * O botão "Exportar" da tela de Leads existia no app antigo mas não fazia
 * nada — era um `<Button>` sem `onClick`.
 */

/**
 * @param {string} nomeArquivo
 * @param {Record<string, unknown>[]} linhas
 */
export function downloadCsv(nomeArquivo, linhas) {
  if (!linhas.length) return;

  const colunas = Object.keys(linhas[0]);
  const conteudo = [
    colunas.map(escapar).join(";"),
    ...linhas.map((linha) => colunas.map((coluna) => escapar(linha[coluna])).join(";")),
  ].join("\r\n");

  // BOM para o Excel em português abrir os acentos corretamente.
  const blob = new Blob(["﻿" + conteudo], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = nomeArquivo;
  link.click();

  URL.revokeObjectURL(url);
}

/** Campos com `;`, aspas ou quebra de linha precisam de aspas duplas. */
function escapar(valor) {
  const texto = valor == null ? "" : String(valor);
  return /[";\r\n]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
}
